// CSS Modules - component class name prefix: ProductDetailSection__

<template>
  <div :class="$style.container"></div>
</template>

<script>
export default {
  name: "ProductDetailSection"
};
</script>

<style module lang="scss">
@import "./ProductDetailSection.scss";
</style>
